module.exports = __webpack_public_path__ + "img/total_premium_white.21a9542.svg";